/**
 * Strips bold and italic markdown formatting from a string.
 * Removes the following patterns:
 * - Bold: **text** or __text__
 * - Italic: *text* or _text_
 * - Bold + Italic: ***text*** or ___text___
 *
 * @param text - The markdown text to strip
 * @returns The plain text without bold/italic formatting
 */
export const stripMarkdown = (text: string): string => {
  return (
    text
      // Remove bold + italic (*** or ___)
      .replace(/(\*{3}|_{3})(.*?)\1/g, "$2")
      // Remove bold (** or __)
      .replace(/(\*{2}|_{2})(.*?)\1/g, "$2")
      // Remove italic (* or _)
      .replace(/(\*{1}|_{1})(.*?)\1/g, "$2")
      .trim()
  );
};
